import FontSizeDropdownContainer from './FontSizeDropdownContainer';

export default FontSizeDropdownContainer;